import { ReactNode } from "react";

export type MaintenanceSectionProps = {
  children?: ReactNode
}

export const MaintenanceSection = ({ children }: MaintenanceSectionProps) => {
  return (
    <div className="w-full font-sans">
      <div className="bg-white m-2 py-[5px] px-[15px]">{children}</div>
    </div>
  );
};
